import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import './IntroText.css'
import template from './IntroText.jinja'

var IntroText = Backbone.View.extend({
    el: '.IntroText',
    events: {
        'click .IntroText-more, .IntroText-less': 'toggleMore'
    },
    initialize () {
        _.bindAll(this, 'toggleMore');

        this.$introMoreButton = this.$('.IntroText-more');
        this.$introLessButton = this.$('.IntroText-less');
        this.$introTextExtended = this.$('.IntroText-moreText');
        this.$htmlBody = $('html, body');
    },
    toggleMore() {
        const isExpanded = this.$introMoreButton.hasClass('isHidden');

        this.$('.IntroText-moreText').slideToggle(300, 'swing', () => {
            if (!isExpanded) {
                this.$introLessButton.removeClass('isHidden');

                return;
            }

            this.$introMoreButton.removeClass('isHidden');
        });

        if (!isExpanded) {
            this.$introMoreButton.addClass('isHidden');

            return;
        }

        this.$introLessButton.addClass('isHidden');

        const expandedTextHeight = this.$introTextExtended.outerHeight();
        const windowScroll = this.$htmlBody.scrollTop();
        const scrollPosition = windowScroll - expandedTextHeight;

        this.$htmlBody.animate({
            scrollTop: scrollPosition
        }, 200);
    }
})

export default IntroText


// WEBPACK FOOTER //
// ./assets/app/front/components/IntroText/IntroText.js